import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';

export interface ConfirmOpenTabDialogData {
  readonly titleKey: string;
  readonly messageKey: string;
  readonly confirmKey: string;
  readonly cancelKey: string;
}

@Component({
  selector: 'app-confirm-open-tab-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ data.titleKey | translate }}</h2>
    <mat-dialog-content>
      <p class="m-0">{{ data.messageKey | translate }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="close(false)">
        {{ data.cancelKey | translate }}
      </button>
      <button mat-flat-button color="primary" type="button" (click)="close(true)">
        {{ data.confirmKey | translate }}
      </button>
    </mat-dialog-actions>
  `,
})
export class ConfirmOpenTabDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmOpenTabDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: ConfirmOpenTabDialogData
  ) {}

  close(value: boolean): void {
    this.dialogRef.close(value);
  }
}
